import { getExceptionFromAxiosError } from '@/client/helpers';
import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import { MyPhishingOverview, MyPhishingSimulationDetail } from './types';

export const myPhishingService = (client: AxiosInstance) => {
  const BASE_URL = '/me/phishing';

  const getOverview = async (): Promise<MyPhishingOverview> => {
    try {
      const result = await client.get<
        MyPhishingOverview,
        AxiosResponse<MyPhishingOverview>
      >(`${BASE_URL}/overview`, {
        withCredentials: true,
      });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const getSimulationDetail = async (
    campaignId: string,
  ): Promise<MyPhishingSimulationDetail> => {
    try {
      const result = await client.get<
        MyPhishingSimulationDetail,
        AxiosResponse<MyPhishingSimulationDetail>
      >(`${BASE_URL}/simulations/${campaignId}`, {
        withCredentials: true,
      });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const markViewed = async (campaignId: string): Promise<void> => {
    try {
      await client.post(
        `${BASE_URL}/simulations/${campaignId}/viewed`,
        {},
        {
          withCredentials: true,
        },
      );
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  return {
    getOverview,
    getSimulationDetail,
    markViewed,
  };
};
